import IconNames from '@/components/atomic/atoms/data-display/icons/symbol/enum';
import SliceNames from '@/state/enum';
import iconExistsSelector from '@/state/selectors/icons/icon-exists';
import { IconsActions } from '@/state/slices/icons/typings';
import { IStore, SetState } from '@/state/slices/typings';

const iconsActionsCreator = (
	set: SetState<IStore>,
	get: () => IStore,
): IconsActions => {
	return {
		[SliceNames.ICONS]: {
			addIcon: (icon: IconNames) => {
				const iconExists = iconExistsSelector(get(), icon);
				if (iconExists) return;
				set(
					(state) => ({
						...state,
						[SliceNames.ICONS]: {
							...state[SliceNames.ICONS],
							icons: [...state[SliceNames.ICONS].icons, icon],
						},
					}),
					undefined,
					{ type: `${SliceNames.ICONS}/addIcon`, icon },
				);
			},
		},
	};
};

export default iconsActionsCreator;
